import {getTranslation} from "../helpers/get-translation";

export default {
	LOGIN: getTranslation("LOGIN_EMAIL_SCREEN_url"),
	REGISTER: getTranslation("REGISTER_EMAIL_SCREEN_url"),
	RESET: getTranslation("RESET_EMAIL_SCREEN_url")
}
